import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
//import { BrowserRouter as Router } from 'react-router-dom';
import store from './redux/store/store.js';
import './index.css';
import axios from 'axios';

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Provider store={store}>      
        <App />           
    </Provider>
  
);

